const commonParser = require('od-modules/parsers/dynpack_common');
const {checkMinimumDiscount} = require('od-modules/helpers/price/dynpack_price_discounts');

function getDefaultData(result, widget) {
    const {offerType} = result;
    return {
        hotelBackgroundImage: commonParser.getBackgroundImageError(result.accommodationInfo.imgUrl, result.noHotelPic),
        onLoadError: commonParser.getOnLoadError(result.noHotelPic),
        isTopChoice: commonParser.isTopChoice(result, widget),
        priceBreakdown: Odigeo.Utils.splitFormatedCurrency(result.price),
        category: commonParser.getHotelCategory(Odigeo._.get(result, 'accommodationInfo.category', {})),
        hasToShowDistance: Odigeo.Utils.isRequestApp('dp'),
        isPrimeEnabled: widget.isPrimeEnabled,
        isPrimeUserLogged: widget.isPrimeUserLogged,
        isPrimeDaysPromotion: offerType === 'PREMIUM_PRIME' || offerType === 'STANDARD_PRIME',
    };
}

function getReviews(result, widget) {
    return {
        reviews: Odigeo._.map(result.accommodationDeal.accommodationSearchReviews, function(review) {
            const tripAdvisorImgId = '0';
            const img = Odigeo.Utils.replaceCmsKeyArgs(
                widget.tripAdvisorImageUrl.replace(/\\/g, ''),
                review.usersRatePattern.replace(',', '.'),
                tripAdvisorImgId
            );
            return Odigeo._.extend({}, review, {
                isTripAdvisor: Odigeo._.isEqual(review.usersRateSource, 'TA'),
                tripAdvisorUrlImage: img,
            });
        }),
    };
}

function getPriceDiscountData(result) {
    const pricePerPaxPlusDiscount = Odigeo._.get(result, 'dynpackFareDiscountDetails.pricePerPassengerWithoutDiscount');
    const pricePerPaxPlusDiscountData = Odigeo.Utils.splitFormatedCurrency(pricePerPaxPlusDiscount);
    const discountPercentage = Odigeo._.get(result, 'dynpackFareDiscountDetails.discountPercentage');
    const discountPercentageData = Math.round(discountPercentage);
    const dynpackFare = Odigeo._.get(result, 'accommodationDeal.dynpackFare');

    return {
        pricePlusDiscountData: pricePerPaxPlusDiscountData,
        discountPercentageData: discountPercentageData,
        hasMinimumDiscount: checkMinimumDiscount({discountPercentage, dynpackFare}),
    };
}

function insertTemplate(tmplName, data) {
    const tmpl = this.templates[tmplName] || Odigeo._.template('');
    const parsedData = Odigeo._.isObject(data) ? data : {};

    return tmpl ? tmpl(Odigeo._.extend({}, parsedData, {
        insertTemplate: Odigeo._.bind(insertTemplate, this),
        keys: this.keys,
        pluralizeAll: Odigeo.Utils.pluralizeAll,
        replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
    })) : '';
}

function getRenderData(result, widget) {
    const data = Odigeo._.extend({}, result,
        getDefaultData(result, widget),
        (widget.isPrimeEnabled && result.priceBreakdownDynpack) ? commonParser.getPrimePriceData(result.priceBreakdownDynpack) : null,
        getReviews(result, widget),
        commonParser.getRoomsLeftData(Odigeo._.get(result, 'accommodationDeal', {})),
        getPriceDiscountData(result, widget));

    return Odigeo._.extend(data, {
        insertTemplate: Odigeo._.bind(insertTemplate, widget),
        templatePrice: commonParser.getPriceTemplate(data, false),
    });
}

module.exports = {
    getRenderData,
};
